import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { FirstHomeBuyers } from './pages/FirstHomeBuyers';
import { HomeBuyers } from './pages/HomeBuyers';
import { Investors } from './pages/Investors';
import { PortfolioStrategy } from './pages/PortfolioStrategy';
import { ToolsPage } from './pages/ToolsPage';
import { FHBClarityTool } from './components/tools/FHBClarityTool';
// ScrollToAnchor component to handle hash links when navigating between pages
function ScrollToAnchor() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function AppLayout({
  isDark,
  toggleTheme
}: {
  isDark: boolean;
  toggleTheme: () => void;
}) {
  const location = useLocation();
  const isClarityPage = location.pathname === '/first-home-buyers/clarity';
  return <div className="min-h-screen bg-[#f8f9fb] dark:bg-[#0f1629] text-slate-800 dark:text-slate-300 font-sans selection:bg-primary-500/30 transition-colors duration-300" data-id="element-0">
      {!isClarityPage && <Navbar isDark={isDark} toggleTheme={toggleTheme} data-id="element-1" />}
      {isClarityPage && <header className="bg-white dark:bg-[#0f1629] border-b border-slate-200 dark:border-white/10 py-4" data-id="element-2">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center" data-id="element-3">
            <Link to="/" className="flex items-center gap-2.5" data-id="element-4">
              <img src={isDark ? 'https://cdn.magicpatterns.com/uploads/ijbn574AJz6iw1qrM49TjL/Blue_and_Black_Minimalist_Brand_Logo_-_4.png' : 'https://cdn.magicpatterns.com/uploads/5vDwqvkMZA2x7h9wkDud7B/Blue_and_Black_Minimalist_Brand_Logo_-_2.png'} alt="Scale Finance Strategies" className="h-9 w-9 rounded-lg object-contain" data-id="element-5" />
              <span className="text-xl font-bold tracking-tight text-slate-900 dark:text-white" data-id="element-6">
                Scale
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-7">
                  FinanceStrategies
                </span>
              </span>
            </Link>
          </div>
        </header>}
      <Routes data-id="element-8">
        <Route path="/" element={<HomePage isDark={isDark} data-id="element-10" />} data-id="element-9" />
        <Route path="/first-home-buyers" element={<FirstHomeBuyers data-id="element-12" />} data-id="element-11" />
        <Route path="/first-home-buyers/clarity" element={<main className="py-12 bg-[#f8f9fb] dark:bg-[#0f1629] min-h-screen transition-colors duration-300" data-id="element-14">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
                <FHBClarityTool data-id="element-16" />
              </div>
            </main>} data-id="element-13" />
        <Route path="/home-buyers" element={<HomeBuyers data-id="element-18" />} data-id="element-17" />
        <Route path="/investors" element={<Investors data-id="element-20" />} data-id="element-19" />
        <Route path="/portfolio-strategy" element={<PortfolioStrategy data-id="element-22" />} data-id="element-21" />
        <Route path="/tools" element={<ToolsPage data-id="element-24" />} data-id="element-23" />
      </Routes>
      <Footer isDark={isDark} minimal={isClarityPage} data-id="element-25" />
    </div>;
}
export function App() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('sf-theme');
    return saved === 'dark';
  });
  useEffect(() => {
    localStorage.setItem('sf-theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const toggleTheme = () => setIsDark(prev => !prev);
  return <Router data-id="element-26">
      <ScrollToAnchor data-id="element-27" />
      <div className={`${isDark ? 'dark' : ''}`} data-id="element-28">
        <AppLayout isDark={isDark} toggleTheme={toggleTheme} data-id="element-29" />
      </div>
    </Router>;
}